import React, {Component} from 'react';
import PropTypes from "prop-types";

class RadioBoxContainer extends Component {

    static propTypes = {
        name: PropTypes.string.isRequired,
        options: PropTypes.array.isRequired,
        onChange: PropTypes.func.isRequired
    };

    static defaultProps = {
        currentOption: null
    };

    constructor(props) {

        super(props);

        this.state = {
            currentOption: props.currentOption
        };

        this.onChange = this.onChange.bind(this);

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.currentOption !== this.props.currentOption) {
            this.setState({
                currentOption: nextProps.currentOption,
            });
        }

    }

    onChange(option) {

        if (!option) return null;

        this.setState({currentOption: option.value});

        this.props.onChange(this.props.name, option.value);

    }

    renderOptions() {

        const {isRequired, ...inputProps} = {...this.props};
        const options = this.props.options;

        return options.map(
            (option) => {
                let classes = ['radioLabel', ((this.state.currentOption === option.value) ? 'isChecked' : '')].join(' ').trim();
                let checked = (this.state.currentOption === option.value);

                return (
                    <label key={option.value} className={classes}>
                        <input
                            {...inputProps}
                            name={this.props.name}
                            type="radio"
                            value={option.value}
                            checked={checked}
                            onChange={() => {this.onChange(option)}}
                        />

                        <i>i</i>

                        <span>{option.label}</span>
                    </label>
                );
            }
        );

    }

    render() {

        const options = this.renderOptions();

        return (
            <div className="formSettings">
                {options}
            </div>
        );

    }

}

export default RadioBoxContainer;